export function newsCategoriesReducer(state = {
  categories: [],
  category: {},
  fetching: false,
  fetched: false,
  saved: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_NEWS_CATEGORY_LIST_PENDING':
    case 'GET_NEWS_CATEGORY_PENDING': {
      return {...state, fetching: true, fetched: false}
    }
    case 'GET_NEWS_CATEGORY_LIST_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        categories: action.payLoad.data,
      }
    }
    case 'GET_NEWS_CATEGORY_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        category: action.payLoad.data,
      }
    }
    case 'GET_NEWS_CATEGORY_LIST_REJECTED':
    case 'GET_NEWS_CATEGORY_REJECTED': {
      return {...state, errors: action.payLoad.errors}
    }
    case 'DELETE_NEWS_CATEGORY_FULFILLED': {
      const newState = {...state};
      newState.categories = newState.categories.filter(category => {
        return category.id !== action.payLoad
      });
      return newState;
    }
    case 'CLEAR_EDIT_NEWS_CATEGORY': {
      return {
        ...state,
        category: {}
      }
    }
    default:
  }

  return {...state};
}

export function newsArticlesReducer(state = {
  articles: [],
  article: {},
  editorInput: {
    statuses: [],
    categories: [],
    articles: [],
    permissions: []
  },
  statusList: [],
  fetching: false,
  fetched: false,
  saved: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_NEWS_ARTICLE_LIST_PENDING':
    case 'GET_NEWS_ARTICLE_PENDING': {
      return {...state, fetching: true, fetched: false}
    }
    case 'GET_NEWS_ARTICLE_LIST_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        articles: action.payLoad.data,
        statusList: action.payLoad.meta.statuses,
      }
    }
    case 'GET_NEWS_ARTICLE_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        article: action.payLoad.data || {},
        editorInput: {
          permissions: [],
          ...action.payLoad.meta,
        }
      }
    }
    case 'GET_NEWS_ARTICLE_LIST_REJECTED':
    case 'GET_NEWS_ARTICLE_REJECTED': {
      return {...state, errors: action.payLoad.errors}
    }
    case 'DELETE_NEWS_ARTICLE_FULFILLED': {
      const newState = {...state};
      newState.articles = newState.articles.filter(article => {
        return article.id !== action.payLoad
      });
      return newState;
    }
    case 'CLEAR_EDIT_NEWS_ARTICLE': {
      return {
        ...state,
        article: {}
      }
    }
    default:
  }

  return {...state};
}



// WEBPACK FOOTER //
// ./src/reducers/newsReducer.js